import { defineNuxtPlugin } from '#app'
import PromiseDialog, { injectionKey } from 'vuejs-dialog'

export default defineNuxtPlugin((nuxtApp) => {
  const dialog = PromiseDialog.installStandalone({
    backdropClose: false,
    closeButton: true,
    closeButtonIcon: 'mdi-close',
    closeButtonPosition: 'top-right',
    closeButtonSize: 'small',
    
  })

  // Inject into Vue's provide/inject system
  nuxtApp.vueApp.provide(injectionKey, dialog)

  // Also add to Nuxt's runtime config for auto-typed `$dialog`
  nuxtApp.provide('dialog', dialog)
})
